import { I18N_NAMESPACE } from "../../../common/constants/i18n"

export const HORIZONTAL_SIGNING_CONDITION_GOOD = 10
export const HORIZONTAL_SIGNING_CONDITION_MEDIUM = 20
export const HORIZONTAL_SIGNING_CONDITION_BAD = 30
export const HORIZONTAL_SIGNING_CONDITION_UNKNOWN = -1
export const HORIZONTAL_SIGNING_CONDITIONS = [
    HORIZONTAL_SIGNING_CONDITION_GOOD,
    HORIZONTAL_SIGNING_CONDITION_MEDIUM,
    HORIZONTAL_SIGNING_CONDITION_BAD,
    HORIZONTAL_SIGNING_CONDITION_UNKNOWN,
]

export const getHorizontalSigningConditionsValues = (t, theme) => ({
    [HORIZONTAL_SIGNING_CONDITION_BAD]: {
        backgroundColor: theme.palette["red/100"]?.main,
        labelColor: theme.palette["error"]?.main,
        color: theme.palette["error"]?.main,
        label: t(I18N_NAMESPACE, "components.horizontalSignsCount.bad"),
        legendLabel: t(I18N_NAMESPACE, "containers.horizontalSign.legend.conditions.texts.bad"),
    },
    [HORIZONTAL_SIGNING_CONDITION_MEDIUM]: {
        backgroundColor: theme.palette["orange/100"]?.main,
        labelColor: theme.palette["_components/legend/DPE/orange-foncé"]?.main,
        color: theme.palette["_components/legend/DPE/orange"]?.main,
        label: t(I18N_NAMESPACE, "components.horizontalSignsCount.medium"),
        legendLabel: t(I18N_NAMESPACE, "containers.horizontalSign.legend.conditions.texts.medium"),
    },
    [HORIZONTAL_SIGNING_CONDITION_GOOD]: {
        backgroundColor: theme.palette["brand logiroad/primary/100"]?.main,
        labelColor: theme.palette["primary"]?.main,
        color: theme.palette["primary"]?.main,
        label: t(I18N_NAMESPACE, "components.horizontalSignsCount.good"),
        legendLabel: t(I18N_NAMESPACE, "containers.horizontalSign.legend.conditions.texts.good"),
    },
    [HORIZONTAL_SIGNING_CONDITION_UNKNOWN]: {
        backgroundColor: theme.palette["common/gray_states"]?.main,
        labelColor: theme.palette["common/gray_states"]?.main,
        color: theme.palette["common/gray_states"]?.dark,
        label: "",
        legendLabel: "",
    },
})

export const getHorizontalSigningLegendConfig = (t, theme) => {
    const conditions = getHorizontalSigningConditionsValues(t, theme)
    return Object.values(conditions).slice(0, -1).map(conditionValue => {
        return {
            color: conditionValue.color,
            label: conditionValue.legendLabel,
        }
    })
}